import { ListItemButton } from "@mui/material"
import { ReactElement } from "react"
import { useMatch } from "react-router-dom"

import { useClickNavButton } from "./useClickNavButton"
import { BORDER_RADIUS } from "../../../../themes/defaultThemeParams"
import AppTooltip from "../../../helper/appTooltip"

type NavButtonProps = {
    icon: ReactElement
    title: string
    route: string
    external?: boolean
}

/**
 * Navigation buttons used on the application navigation bar when it is
 * displayed in "vertical" mode (i.e. as a navigation bar listed on the
 * left hand side of the desktop screen) and the nav-bar has been collapsed.
 *
 * @example
 * < NavButtonVerticalCollapsed title="test" icon={Icon} route="/"/>
 */
const NavButtonVerticalCollapsed = ({
    icon,
    title,
    route,
    external,
}: NavButtonProps): ReactElement => {
    const { clickNavButton } = useClickNavButton(route, external)
    const selected = !!useMatch(route)
    return (
        <AppTooltip title={title}>
            <ListItemButton
                sx={{
                    borderRadius: BORDER_RADIUS,
                    padding: "14px 8px 14px 8px",
                    marginBottom: 0.5,
                    justifyContent: "center",
                }}
                color="primary"
                selected={selected}
                onClick={clickNavButton}
            >
                {icon}
            </ListItemButton>
        </AppTooltip>
    )
}

NavButtonVerticalCollapsed.defaultProps = {
    external: false,
}

export default NavButtonVerticalCollapsed
